import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import type { SyncProvider } from '@/components/onboarding/sync-progress-screen';

interface SyncBannerState {
  /** domainId of the active sync (null when nothing is running) */
  domainId: string | null;
  /** Which provider is syncing — drives banner hero styling */
  provider: SyncProvider | null;
  /** User-dismissed this specific sync? Hidden until a new one starts. */
  dismissedDomainId: string | null;
  setActive: (domainId: string, provider: SyncProvider) => void;
  clear: () => void;
  dismiss: () => void;
}

export const useSyncBannerStore = create<SyncBannerState>()(
  devtools(
    persist(
      (set, get) => ({
        domainId: null,
        provider: null,
        dismissedDomainId: null,
        setActive: (domainId, provider) => {
          // Starting a new sync undoes any prior dismissal
          set({
            domainId,
            provider,
            dismissedDomainId:
              get().dismissedDomainId === domainId
                ? get().dismissedDomainId
                : null,
          });
        },
        clear: () =>
          set({ domainId: null, provider: null, dismissedDomainId: null }),
        dismiss: () => {
          const { domainId } = get();
          if (domainId) set({ dismissedDomainId: domainId });
        },
      }),
      {
        name: 'hf-app:sync-banner',
      },
    ),
    { name: 'SyncBannerStore' },
  ),
);
